var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ScrollSelect", {
    ref: "scrollSelect",
    attrs: {
      api: _vm.api,
      placeholder: _vm.placeholder || _vm.$t("chooseText"),
      multiple: _vm.multiple,
      disabled: _vm.disabled,
      size: _vm.size,
      "default-params": _vm.defaultParams,
      "default-options": _vm.defaultOptions,
      remote: _vm.remote,
      "search-key": "name",
      "option-label": "name",
      "option-value": _vm.optionValue,
      "option-enabled": "enableFlag",
      "res-key": "content",
    },
    on: { change: _vm.onChange, blur: _vm.onBlur },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v
      },
      expression: "id",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }